export default __webpack_public_path__ + "static/media/21.f08345e8.PNG";